import {
  Modal,
  Box,
  Typography,
  TextField,
  IconButton,
  Button,
  Grid,
} from "@mui/material"
import ClearIcon from "@mui/icons-material/Clear"
import { useEffect, useState } from "react"

const AddCurrencyNoteModel = ({
  open,
  onClose, 
  onSubmit
}) => {
  const [noteValue, setNoteValue] = useState("")
  
  const handleSubmit = (event) => {
    event.preventDefault()
    console.log('submit clicked', noteValue)
    if (onSubmit) {
      onSubmit(noteValue) 
    }
    setNoteValue('')
  }

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          maxWidth: 500,
          margin: "100px auto",
          padding: 1,
          bgcolor: "white",
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#f6f7f9",
            padding: { xs: "15px 20px", md: "25px" },
          }}
          className="rmu-modal-header"
        >
          <Typography
            id="modal-modal-title"
            variant="h6"
            sx={{
              fontWeight: "600",
              fontSize: { xs: "16px", md: "18px" },
            }}
            className="text-black"
          >
            Add Currency
          </Typography>
          <IconButton
            aria-label="remove"
            size="small"
            onClick={onClose}
          >
            <ClearIcon />
          </IconButton>
        </Box>
        <Box
          sx={{ padding: 2 }}
          component="form"
          onSubmit={handleSubmit}
          noValidate
        >
         <TextField
  fullWidth
  label="Note value"
  placeholder="Eg: 100"
  sx={{ marginBottom: 2 }}
  value={noteValue}
  onChange={(e) => setNoteValue(e.target.value)}
/>

          <TextField
            fullWidth
            label="Key"
            type="number"
            sx={{ display: "none", marginBottom: 2 }}
            InputProps={{
              readOnly: true, // Makes the field non-editable
            }}
          />

          <Grid item xs={12} mt={1}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
                gap: "10px",
              }}
            >
      

              <Button
                onClick={onClose}
                variant="outlined"
                color="error"
                sx={{
                  textTransform: "capitalize",
                  borderRadius: "8px",
                  fontWeight: "500",
                  fontSize: "13px",
                  padding: "11px 30px",
                }}
              >
                Cancel
              </Button>

              <Button
                type="submit"
                disabled={!noteValue}
                variant="contained"
                sx={{
                  textTransform: "capitalize",
                  borderRadius: "8px",
                  fontWeight: "500",
                  fontSize: "13px",
                  padding: "11px 30px",
                  color: "#fff !important",
                }}
              >
                 Update
              </Button>
            </Box>
          </Grid>
        </Box>
      </Box>
    </Modal>
  )
}

export default AddCurrencyNoteModel
